import { forwardRef, Ref } from 'react'

import NextLink, { type LinkProps } from 'next/link'

import BasicLink, { type BasicLinkProps } from './BasicLink'

interface CustomLinkProps
  extends Omit<React.AllHTMLAttributes<HTMLAnchorElement>, 'as'>,
    BasicLinkProps,
    LinkProps {
  href: string
  isBasic?: boolean
  newTab?: boolean
}

const CustomLink = (
  {
    ariaHidden,
    ariaLabelledby,
    className,
    children,
    href,
    isBasic,
    onClick,
    tabIndex,
    newTab,
    ...rest
  }: CustomLinkProps,
  ref: Ref<HTMLAnchorElement>,
) => {
  if (isBasic) {
    return (
      <BasicLink
        ariaHidden={ariaHidden}
        ariaLabelledby={ariaLabelledby}
        className={className}
        href={href}
        onClick={onClick}
        newTab={newTab}
        {...rest}
        ref={ref}
      >
        {children}
      </BasicLink>
    )
  }

  return (
    <NextLink
      aria-hidden={ariaHidden}
      aria-labelledby={ariaLabelledby}
      className={className}
      onClick={onClick}
      ref={ref}
      tabIndex={tabIndex}
      target={newTab ? '_blank' : undefined}
      href={href}
      {...rest}
    >
      {children}
    </NextLink>
  )
}

export default forwardRef(CustomLink)
